<template>
    <div class="deck-plan-content" v-show="isShow">
        <div class="deck-plan-bg"></div>
        <div class="deck-plan-details">
            <div class="plan-details">
                <div class="plan-details-title">甲板图</div>
                <div class="details-content">
                    <div class="details-img js-smartScroll">
                        <img :src="deckImage">
                    </div>
                    <div class="details-storey-content js-smartScroll">
                        <div class="storey-num-content">
                            <div class="storey-num-title">选择楼层</div>
                            <div class="storey-num-details js-smartScroll">
                                <div class="storey-num"
                                v-for="(deck, i) in decks" :key="('key_'+i)"
                                :class="{ active: deck == selectedDeck}"
                                @click="changeDeck(deck)"
                                >
                                    {{getDeckCN(deck)}}
                                </div>
                            </div>
                        </div>
                        <div class="room-number-content">
                            <div class="room-num-title">请选择房间号</div>
                            <div class="room-num-details js-smartScroll">
                                <div class="room-num"
                                v-for="(cabinNumber, j) in getCabinsByDeck(selectedDeck)" :key="('cabin_' + j)"
                                :class=" { active: cabinNumber == selectedCabinNumber}"
                                @click="changeCabin(cabinNumber)"
                                >
                                    {{cabinNumber}}
                                </div>
                            </div>
                        </div>
                        <div class="deck-confirm-btn" @click="onCabinConfirm()">确定</div>
                        <div class="deck-confirm-desc">*该甲板图仅供参考，请以实际可选房间号及房间信息为准。</div>
                    </div>
                    <div class="storey-img">
                        <img src="https://resource.rcclchina.com.cn/images/slide.png">
                    </div>
                </div>
                <div class="deck-close" @click="closeChangeStateroom()"><img src="https://resource.rcclchina.com.cn/cruiseDetail/closed.png"></div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import deckHelper from '@/utilities/deckHelper'
export default {
    name: 'GuestInfoChangeStateroom',
    props: {
        isShow: {
            type: Boolean
        },
        booking: {
            type: Object,
            default () {
                return {
                    "sessionToken": "",
                    "stateroomNumber": "",
                    "deckNumber": ""
                }
            }
        },
        cabins: {
            type: Array,
            default () {
                return []
            }
        },
        closeChangeStateroom: {
            type: Function
        },
        onChangeStateroomConfirm: {
            type: Function
        }
    },
    data () {
        return {
            selectedDeck: '',
            selectedCabinNumber: ''
        }
    },
    methods: {
        getDeckCN(deck) {
            return deckHelper.transferDeckCN(deck)
        },
        getCabinsByDeck (deck) {
            const deckNumber = deck + ''
            let items = this.cabins.filter(r=>r.deckNumber == deckNumber).map(r=>r.cabinNumber)
            if (this.bookingDeckNumber && this.bookingDeckNumber.length > 0
            && this.bookingStateroomNumber && this.bookingStateroomNumber.length > 0) {
                if (deckNumber == this.bookingDeckNumber && !items.some(r=>r == this.bookingStateroomNumber)) {
                    items.push(this.bookingStateroomNumber)
                }
            }
            return _.orderBy(items)
        },
        changeDeck (deck) {
            this.selectedDeck = deck + ''
        },
        changeCabin (cabinNumber) {
            this.selectedCabinNumber = cabinNumber
        },
        onCabinConfirm () {
            this.onChangeStateroomConfirm(this.booking.sessionToken, this.selectedCabinNumber, this.selectedDeck)
        }
    },
    computed: {
        deckImage() {
            const imgUrl = process.env.VUE_APP_IMG_URL;
            const shipCode = this.booking.shipCode
            if (!shipCode || shipCode.length == 0 || !this.selectedDeck || this.selectedDeck.length == 0) {
                return ''
            }
            let image = `${imgUrl}/DeckImages/${shipCode}${this.selectedDeck}.jpg`
            // 2021SC, 2019QN特殊图片
            const sailDate = this.booking.sailDate
            const sailDateTime = new Date(sailDate)
            if (shipCode == 'SC') {
                image = `${imgUrl}/DeckImages/${shipCode}${this.selectedDeck}.jpg`
            } else if (shipCode == 'OV') {
                image = `${imgUrl}/DeckImages/2024/${shipCode}${this.selectedDeck}.jpg`
            } else if (shipCode == 'QN' && sailDateTime.getTime() >= new Date('2019-01-01').getTime()) {
                image = `${imgUrl}/DeckImages/${shipCode}2019${this.selectedDeck}.jpg`
            } else if (shipCode == 'NV') {
              image = `${imgUrl}/DeckImages/2025/${shipCode}${this.selectedDeck}.jpg`
            }
            return image
        },
        decks () {
            let decks = []
            this.cabins && this.cabins.forEach((cabin) => {
                const deckNumber = parseInt(cabin.deckNumber)
                if (!decks.some(r=>r==deckNumber)) {
                    decks.push(deckNumber)
                }
            })
            if (this.bookingDeckNumber && this.bookingDeckNumber.length > 0) {
                const bookingDeck = parseInt(this.bookingDeckNumber)
                if (!decks.some(r=>r==bookingDeck)) {
                    decks.push(bookingDeck)
                }
            }

            decks = _.orderBy(decks, null,'desc')
            return decks
        },
        bookingStateroomNumber () {
            return this.booking.stateroomNumber
        },
        bookingDeckNumber () {
            return this.booking.deckNumber
        }
    },
    watch: {
        booking(newOne) {
            this.selectedCabinNumber = newOne.stateroomNumber
            this.selectedDeck = newOne.deckNumber
        }
    }
}
</script>

<style lang="less" scoped>
.deck-plan-content {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    z-index: 100;
    display: block;
    .deck-plan-bg {
        position: relative;
        width: 100%;
        height: 100%;
        background: #000;
        opacity: .8;
        top: 0;
        z-index: 20;
    }
    .deck-plan-details {
        position: absolute;
        top: 90px;
        width: 100%;
        padding: 0 10px;
        height: calc(100% - 130px);
        overflow: hidden;
        z-index: 20;
    }
    .plan-details {
        background: #fff;
        height: 100%;
        padding: 0 5px;
        position: relative;
        .plan-details-title {
            width: 345px;
            text-align: center;
            height: 40px;
            line-height: 40px;
            border-bottom: 1px solid #eaeaea;
            color: #061556;
            font-size: 14px;
            font-weight: 600;
            overflow: hidden;
        }
        .details-content {
            position: relative;
            height: calc(100% - 40px);
            .details-img {
                width: 200px;
                border-right: 2px solid #e2e2e2;
                height: 100%;
                overflow-y: scroll;
                img {
                    width: 100%;
                }
            }
            .details-storey-content {
                width: 140px;
                padding: 10px 5px 20px;
                height: 100%;
                overflow-x: hidden;
                overflow-y: scroll;
                .storey-num-content, .room-number-content {
                    width: 100%;
                    height: 40%;
                    overflow: hidden;
                }
                .storey-num-content .storey-num-title, .room-number-content .room-num-title {
                    width: 130px;
                    height: 21px;
                    color: #061556;
                    font-size: 14px;
                    font-weight: 600;
                    text-align: center;
                    overflow: hidden;
                }
                .storey-num-details {
                    width: 100%;
                    padding: 2px 0;
                    height: 126px;
                    overflow-y: auto;
                    .storey-num {
                        width: 108px;
                        height: 35px;
                        text-align: center;
                        line-height: 35px;
                        font-size: 14px;
                        margin: 5px auto;
                        border: 1px solid #c4c4c4;
                        overflow: hidden;
                    }

                }
                .storey-num-content .active {
                    background: #061556;
                    color: #fff;
                }
                .room-number-content .room-num-details {
                    width: 100%;
                    height: 130px;
                    overflow-y: auto;
                    text-align: left;
                    padding-bottom: 10px;
                    margin-left: 9px;
                    .room-num {
                        display: inline-block;
                        width: 52px;
                        height: 30px;
                        vertical-align: top;
                        text-align: center;
                        font-size: 13px;
                        color: #333333;
                        margin: 2px;
                        overflow: hidden;
                        line-height: 30px;
                        border: 1px solid #333333;
                    }
                    .active {
                        background: #061556;
                        color: #fff;
                    }
                }
                .deck-confirm-btn {
                    width: 120px;
                    height: 30px;
                    text-align: center;
                    background: #f0af11;
                    color: #fff;
                    font-size: 13px;
                    line-height: 30px;
                    overflow: hidden;
                    margin: 15px auto 0;
                }
                .deck-confirm-desc {
                  font-size: 12px;
                  width: 120px;
                  transform: scale(.95);
                  margin-top: 10px;
                  margin-left: 2px;
                  line-height: 1.3;
                  color: #999999;
                }
            }
            .storey-img {
                position: absolute;
                width: 12px;
                top: 15px;
                left: 202px;
                img {
                    width: 100%;
                }
            }
        }
    }
    .deck-close {
        position: absolute;
        width: 25px;
        height: 25px;
        overflow: hidden;
        top: 5px;
        right: 5px;
        img {
            width: 100%;
        }
    }

    .details-img, .details-storey-content {
        display: inline-block;
        vertical-align: top;
    }
}
</style>
